export const TOGGLE_SHOW_DEMO = 'TOGGLE_SHOW_DEMO';

export function toggleShowDemo(showDemo){
    return{
        type: TOGGLE_SHOW_DEMO,
        mainState: {
            showDemo: showDemo
        }
    }
}